/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../instruments/models';
import '../../../common/currency';
import '../../../common/time';
import '../../common';
import '../payment_plan/models';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "capital": {
        "nested": {
          "servicing": {
            "nested": {
              "plan": {
                "nested": {
                  "models": {
                    "nested": {
                      "Plan": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "version": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "updatedAt": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "payers": {
                            "type": "squareup.capital.servicing.plan.models.Payer",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "cancelableExpiredAt": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "closedAt": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "status": {
                            "type": "squareup.capital.servicing.plan.models.Plan.Status",
                            "id": 8,
                            "rule": "optional"
                          },
                          "contractId": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "investor": {
                            "type": "squareup.capital.servicing.plan.models.Investor",
                            "id": 10,
                            "rule": "optional"
                          },
                          "fund": {
                            "type": "squareup.capital.servicing.plan.models.Fund",
                            "id": 11,
                            "rule": "optional"
                          },
                          "tags": {
                            "type": "squareup.capital.servicing.plan.models.Tag",
                            "id": 12,
                            "rule": "repeated"
                          },
                          "defaultStatus": {
                            "type": "squareup.capital.servicing.plan.models.Plan.DefaultStatus",
                            "id": 13,
                            "rule": "optional"
                          },
                          "isCancelable": {
                            "type": "bool",
                            "id": 14,
                            "rule": "optional"
                          },
                          "documents": {
                            "type": "squareup.capital.servicing.plan.models.Document",
                            "id": 15,
                            "rule": "repeated"
                          },
                          "supportResources": {
                            "type": "squareup.capital.servicing.plan.models.SupportResource",
                            "id": 16,
                            "rule": "repeated"
                          },
                          "activatedAt": {
                            "type": "string",
                            "id": 17,
                            "rule": "optional"
                          },
                          "legacyId": {
                            "type": "string",
                            "id": 18,
                            "rule": "optional"
                          },
                          "isPrepayable": {
                            "type": "bool",
                            "id": 19,
                            "rule": "optional"
                          },
                          "isOriginated": {
                            "type": "bool",
                            "id": 20,
                            "rule": "optional"
                          },
                          "allocatedAt": {
                            "type": "string",
                            "id": 21,
                            "rule": "optional"
                          },
                          "productName": {
                            "type": "string",
                            "id": 22,
                            "rule": "optional"
                          },
                          "amounts": {
                            "type": "squareup.capital.servicing.plan.models.Amounts",
                            "id": 23,
                            "rule": "optional"
                          },
                          "percentageComplete": {
                            "type": "string",
                            "id": 24,
                            "rule": "optional"
                          },
                          "covidReliefEndedAt": {
                            "type": "string",
                            "id": 25,
                            "rule": "optional"
                          },
                          "covidReliefStartedAt": {
                            "type": "string",
                            "id": 26,
                            "rule": "optional"
                          },
                          "pppIsNonEmployer": {
                            "type": "bool",
                            "id": 27,
                            "rule": "optional"
                          },
                          "pppIsHigherOffer": {
                            "type": "bool",
                            "id": 28,
                            "rule": "optional"
                          },
                          "covidCadence": {
                            "type": "squareup.capital.servicing.plan.models.CovidCadence",
                            "id": 29,
                            "rule": "optional"
                          },
                          "maturedAt": {
                            "type": "string",
                            "id": 30,
                            "rule": "optional"
                          },
                          "countryCode": {
                            "type": "string",
                            "id": 200,
                            "rule": "optional"
                          },
                          "productVersion": {
                            "type": "string",
                            "id": 201,
                            "rule": "optional"
                          },
                          "isRateCapped": {
                            "type": "bool",
                            "id": 202,
                            "rule": "optional"
                          },
                          "loanFixedPayments": {
                            "type": "squareup.capital.servicing.plan.models.LoanFixedPaymentsDetail",
                            "id": 150
                          },
                          "loanPortionOfSales": {
                            "type": "squareup.capital.servicing.plan.models.LoanPortionOfSalesDetail",
                            "id": 151
                          },
                          "mca": {
                            "type": "squareup.capital.servicing.plan.models.McaDetail",
                            "id": 152
                          },
                          "retailInstallments": {
                            "type": "squareup.capital.servicing.plan.models.RisaDetail",
                            "id": 153
                          }
                        },
                        "nested": {
                          "Status": {
                            "values": {
                              "S_DO_NOT_USE": 0,
                              "ACTIVE": 1,
                              "ACTIVE_PAST_DUE": 2,
                              "CANCELED": 3,
                              "CLOSED": 4,
                              "CANCEL_PENDING": 5
                            }
                          },
                          "DefaultStatus": {
                            "fields": {
                              "status": {
                                "type": "squareup.capital.servicing.plan.models.Plan.DefaultStatus.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "reasons": {
                                "type": "squareup.capital.servicing.plan.models.Plan.DefaultStatus.Reason",
                                "id": 2,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "Status": {
                                "values": {
                                  "DS_DO_NOT_USE": 0,
                                  "CURRENT": 1,
                                  "DEFAULT_PAST_DUE": 2,
                                  "DEFAULT_NON_MONETARY": 3,
                                  "DEFAULT_ACCELERATED": 4,
                                  "DEFAULT_UNCOLLECTIBLE": 5,
                                  "DEFAULT_DISCHARGED": 6,
                                  "DEFAULT_PAST_DUE_ABBREVIATED_CADENCE": 7,
                                  "DEFAULT_MATURITY": 8,
                                  "DEFAULT_DEACTIVATED": 9,
                                  "DEFAULT_PAST_DUE_V2": 10
                                }
                              },
                              "Reason": {
                                "values": {
                                  "DR_DO_NOT_USE": 0,
                                  "NO_TRANSFER": 1,
                                  "CARD_PROCESSING": 2,
                                  "BUSINESS_OPERATIONS": 3,
                                  "BUSINESS_NAME": 4,
                                  "BUSINESS_CONTROL": 5,
                                  "BUSINESS_SOLD": 6,
                                  "BANK_REQUEST": 7,
                                  "COOPERATION": 8,
                                  "INSPECTION": 9,
                                  "BANKRUPTCY_DEBT_DISCHARGED": 10
                                }
                              }
                            }
                          },
                          "detail": {
                            "oneof": ["loanFixedPayments", "loanPortionOfSales", "mca", "retailInstallments"]
                          }
                        }
                      },
                      "Payer": {
                        "fields": {
                          "customerId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "isPrimary": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          },
                          "canDebitSqBalanceLinkedAccount": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional"
                          },
                          "businessName": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "instruments": {
                            "type": "squareup.capital.servicing.instruments.models.InstrumentSummary",
                            "id": 6,
                            "rule": "repeated"
                          }
                        }
                      },
                      "Investor": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "version": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "updatedAt": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "Fund": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "version": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "updatedAt": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "Tag": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "Amounts": {
                        "fields": {
                          "pendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "baseAmounts": {
                            "type": "squareup.capital.servicing.plan.models.Amounts.BaseAmounts",
                            "id": 2,
                            "rule": "optional"
                          },
                          "detailAmounts": {
                            "type": "squareup.capital.servicing.plan.models.Amounts.DetailAmounts",
                            "id": 3,
                            "rule": "optional"
                          },
                          "detailAmountsPendingApplied": {
                            "type": "squareup.capital.servicing.plan.models.Amounts.DetailAmounts",
                            "id": 4,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "BaseAmounts": {
                            "fields": {
                              "paidMoney": {
                                "type": "squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "remainingMoney": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "DetailAmounts": {
                            "fields": {
                              "paidMoney": {
                                "type": "squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "penaltyMoney": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "pastDueMoney": {
                                "type": "squareup.common.Money",
                                "id": 3,
                                "rule": "optional"
                              },
                              "dueMoney": {
                                "type": "squareup.common.Money",
                                "id": 4,
                                "rule": "optional"
                              },
                              "remainingMoney": {
                                "type": "squareup.common.Money",
                                "id": 5,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "CovidCadence": {
                        "fields": {
                          "type": {
                            "type": "squareup.capital.servicing.plan.models.CovidCadence.CovidCadenceType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "isPaused": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "maturity": {
                            "type": "squareup.capital.servicing.plan.models.CovidCadence.MaturityDetail",
                            "id": 101
                          }
                        },
                        "nested": {
                          "CovidCadenceType": {
                            "values": {
                              "CCT_DO_NOT_USE": 0,
                              "PAST_DUE": 1,
                              "MATURITY_PARTIAL": 2,
                              "MATURITY_FULL": 3
                            }
                          },
                          "MaturityDetail": {
                            "fields": {
                              "firstMaturityDebitExpectedAt": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "detail": {
                            "oneof": ["maturity"]
                          }
                        }
                      },
                      "LoanFixedPaymentsDetail": {
                        "fields": {
                          "financingTerms": {
                            "type": "squareup.capital.servicing.plan.models.FinancingTerms.Loan",
                            "id": 1,
                            "rule": "optional"
                          },
                          "repaymentTerms": {
                            "type": "squareup.capital.servicing.plan.models.RepaymentTerms.FixedPayments",
                            "id": 2,
                            "rule": "optional"
                          },
                          "dueMoney": {
                            "type": "squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "pastDueStartedAt": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "pastDueMoney": {
                            "type": "squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "lateFeeMoney": {
                            "type": "squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "paidMoney": {
                            "type": "squareup.common.Money",
                            "id": 7,
                            "rule": "optional"
                          },
                          "remainingMoney": {
                            "type": "squareup.common.Money",
                            "id": 8,
                            "rule": "optional"
                          },
                          "pendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 9,
                            "rule": "optional"
                          },
                          "percentageComplete": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "scheduledPayments": {
                            "type": "squareup.capital.servicing.plan.models.ScheduledPayment",
                            "id": 11,
                            "rule": "repeated"
                          },
                          "totalDueMoney": {
                            "type": "squareup.common.Money",
                            "id": 12,
                            "rule": "optional"
                          },
                          "dueAndPastDueMoney": {
                            "type": "squareup.common.Money",
                            "id": 13,
                            "rule": "optional"
                          },
                          "remainingExcludingPastDueMoney": {
                            "type": "squareup.common.Money",
                            "id": 14,
                            "rule": "optional"
                          },
                          "dueAndPastDueExcludingPendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 19,
                            "rule": "optional"
                          },
                          "remainingExcludingPendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 16,
                            "rule": "optional"
                          },
                          "remainingExcludingPastDueAndPendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 17,
                            "rule": "optional"
                          },
                          "lateFeeExcludingPendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 18,
                            "rule": "optional"
                          },
                          "pastDueExcludingPendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 15,
                            "rule": "optional"
                          },
                          "firstObligationDueDate": {
                            "type": "string",
                            "id": 20,
                            "rule": "optional"
                          },
                          "nextObligationDueDate": {
                            "type": "string",
                            "id": 22,
                            "rule": "optional"
                          },
                          "principalBalanceMoney": {
                            "type": "squareup.common.Money",
                            "id": 25,
                            "rule": "optional"
                          },
                          "interestBalanceMoney": {
                            "type": "squareup.common.Money",
                            "id": 21,
                            "rule": "optional"
                          },
                          "forgivenessMoney": {
                            "type": "squareup.common.Money",
                            "id": 23,
                            "rule": "optional"
                          },
                          "netForgivenessMoney": {
                            "type": "squareup.common.Money",
                            "id": 26,
                            "rule": "optional"
                          },
                          "forgivenessDecisionDate": {
                            "type": "string",
                            "id": 24,
                            "rule": "optional"
                          },
                          "interestPaidMoney": {
                            "type": "squareup.common.Money",
                            "id": 27,
                            "rule": "optional"
                          },
                          "principalBalanceExcludingPendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 28,
                            "rule": "optional"
                          },
                          "interestBalanceExcludingPendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 29,
                            "rule": "optional"
                          },
                          "interestPaidIncludingPendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 30,
                            "rule": "optional"
                          },
                          "canUse3508s": {
                            "type": "bool",
                            "id": 31,
                            "rule": "optional"
                          },
                          "interestAccruedMoney": {
                            "type": "squareup.common.Money",
                            "id": 32,
                            "rule": "optional"
                          },
                          "forgivenessApplicationId": {
                            "type": "string",
                            "id": 33,
                            "rule": "optional"
                          },
                          "pppGuarantyStatus": {
                            "type": "string",
                            "id": 34,
                            "rule": "optional"
                          },
                          "pppGuarantyApprovedAt": {
                            "type": "squareup.common.time.DateTime",
                            "id": 35,
                            "rule": "optional"
                          },
                          "pppGuarantyApprovedAmount": {
                            "type": "squareup.common.Money",
                            "id": 36,
                            "rule": "optional"
                          },
                          "collectionConfiguration": {
                            "type": "squareup.capital.servicing.plan.models.CollectionConfiguration.FixedPayments",
                            "id": 37,
                            "rule": "optional"
                          }
                        }
                      },
                      "LoanPortionOfSalesDetail": {
                        "fields": {
                          "financingTerms": {
                            "type": "squareup.capital.servicing.plan.models.FinancingTerms.Loan",
                            "id": 1,
                            "rule": "optional"
                          },
                          "repaymentTerms": {
                            "type": "squareup.capital.servicing.plan.models.RepaymentTerms.PortionOfSales",
                            "id": 2,
                            "rule": "optional"
                          },
                          "dueMoney": {
                            "type": "squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "pastDueStartedAt": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "pastDueMoney": {
                            "type": "squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "paidMoney": {
                            "type": "squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "remainingMoney": {
                            "type": "squareup.common.Money",
                            "id": 7,
                            "rule": "optional"
                          },
                          "pendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 8,
                            "rule": "optional"
                          },
                          "paymentPeriodEndedAt": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "percentageComplete": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "periodRequiredMoney": {
                            "type": "squareup.common.Money",
                            "id": 11,
                            "rule": "optional"
                          },
                          "periodPaidMoney": {
                            "type": "squareup.common.Money",
                            "id": 12,
                            "rule": "optional"
                          },
                          "periodRemainingMoney": {
                            "type": "squareup.common.Money",
                            "id": 13,
                            "rule": "optional"
                          },
                          "totalDueMoney": {
                            "type": "squareup.common.Money",
                            "id": 14,
                            "rule": "optional"
                          },
                          "dueAndPastDueMoney": {
                            "type": "squareup.common.Money",
                            "id": 15,
                            "rule": "optional"
                          },
                          "remainingExcludingPastDueMoney": {
                            "type": "squareup.common.Money",
                            "id": 16,
                            "rule": "optional"
                          },
                          "periodRemainingExcludingPendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 17,
                            "rule": "optional"
                          },
                          "pastDueExcludingPendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 18,
                            "rule": "optional"
                          },
                          "remainingExcludingPendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 19,
                            "rule": "optional"
                          },
                          "remainingExcludingPastDueAndPeriodRemainingAndPendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 20,
                            "rule": "optional"
                          },
                          "remainingExcludingPastDueAndPendingMoney": {
                            "type": "squareup.common.Money",
                            "id": 21,
                            "rule": "optional"
                          },
                          "percentageCompleteIncludingPending": {
                            "type": "string",
                            "id": 22,
                            "rule": "optional"
                          }
                        }
                      },
                      "McaDetail": {
                        "fields": {
                          "financingTerms": {
                            "type": "squareup.capital.servicing.plan.models.FinancingTerms.Mca",
                            "id": 1,
                            "rule": "optional"
                          },
                          "repaymentTerms": {
                            "type": "squareup.capital.servicing.plan.models.RepaymentTerms.PortionOfSales",
                            "id": 2,
                            "rule": "optional"
                          },
                          "paidMoney": {
                            "type": "squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "remainingMoney": {
                            "type": "squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "percentageComplete": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "RisaDetail": {
                        "fields": {}
                      },
                      "ScheduledPayment": {
                        "fields": {
                          "status": {
                            "type": "squareup.capital.servicing.plan.models.ScheduledPayment.Status",
                            "id": 1,
                            "rule": "optional"
                          },
                          "debitedAt": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "debitMoney": {
                            "type": "squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "lateFeeAppliedAt": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "lateFeeMoney": {
                            "type": "squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "remainingNonDueMoney": {
                            "type": "squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "remainingDueMoney": {
                            "type": "squareup.common.Money",
                            "id": 7,
                            "rule": "optional"
                          },
                          "remainingPastDueMoney": {
                            "type": "squareup.common.Money",
                            "id": 8,
                            "rule": "optional"
                          },
                          "remainingLateFeeMoney": {
                            "type": "squareup.common.Money",
                            "id": 9,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Status": {
                            "values": {
                              "S_DO_NOT_USE": 0,
                              "SCHEDULED": 1,
                              "COMPLETED": 2,
                              "DUE": 3,
                              "PAST_DUE": 4,
                              "CANCELED": 5,
                              "PENDING": 6
                            }
                          }
                        }
                      },
                      "FinancingTerms": {
                        "nested": {
                          "Loan": {
                            "fields": {
                              "financedMoney": {
                                "type": "squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "feeMoney": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "depositMoney": {
                                "type": "squareup.common.Money",
                                "id": 3,
                                "rule": "optional"
                              },
                              "outstandingBalanceMoney": {
                                "type": "squareup.common.Money",
                                "id": 4,
                                "rule": "optional"
                              },
                              "totalOwedMoney": {
                                "type": "squareup.common.Money",
                                "id": 5,
                                "rule": "optional"
                              },
                              "aprBps": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              },
                              "lateFeeBps": {
                                "type": "string",
                                "id": 7,
                                "rule": "optional"
                              },
                              "postMaturitySweeperBps": {
                                "type": "string",
                                "id": 8,
                                "rule": "optional"
                              },
                              "feeAmountBps": {
                                "type": "string",
                                "id": 9,
                                "rule": "optional"
                              }
                            }
                          },
                          "Mca": {
                            "fields": {
                              "financedMoney": {
                                "type": "squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "feeMoney": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "depositMoney": {
                                "type": "squareup.common.Money",
                                "id": 3,
                                "rule": "optional"
                              },
                              "outstandingBalanceMoney": {
                                "type": "squareup.common.Money",
                                "id": 4,
                                "rule": "optional"
                              },
                              "totalOwedMoney": {
                                "type": "squareup.common.Money",
                                "id": 5,
                                "rule": "optional"
                              },
                              "feeAmountBps": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "RepaymentTerms": {
                        "nested": {
                          "PortionOfSales": {
                            "fields": {
                              "holdRateBps": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "minimumPaymentMoney": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "paymentPeriod": {
                                "type": "squareup.capital.common.PaymentPeriod",
                                "id": 3,
                                "rule": "optional"
                              },
                              "paymentPeriodLength": {
                                "type": "int32",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          },
                          "FixedPayments": {
                            "fields": {
                              "paymentMoney": {
                                "type": "squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "finalPaymentMoney": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "paymentCount": {
                                "type": "int64",
                                "id": 3,
                                "rule": "optional"
                              },
                              "paymentFrequency": {
                                "type": "squareup.capital.servicing.plan.models.RepaymentTerms.FixedPayments.PaymentFrequency",
                                "id": 4,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "PaymentFrequency": {
                                "values": {
                                  "PF_DO_NOT_USE": 0,
                                  "MONTHLY": 1,
                                  "DAILY": 2
                                }
                              }
                            }
                          }
                        }
                      },
                      "CollectionConfiguration": {
                        "nested": {
                          "FixedPayments": {
                            "fields": {
                              "holdRateBps": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "holdRateEffectiveAt": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "Document": {
                        "fields": {
                          "createdAt": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "type": {
                            "type": "squareup.capital.servicing.plan.models.Document.DocumentType",
                            "id": 3,
                            "rule": "optional"
                          },
                          "url": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "DocumentType": {
                            "values": {
                              "DT_DO_NOT_USE": 0,
                              "FUTURE_RECEIVABLES_AGREEMENT": 1,
                              "LOAN_AGREEMENT": 2
                            }
                          }
                        }
                      },
                      "SupportResource": {
                        "fields": {
                          "type": {
                            "type": "squareup.capital.servicing.plan.models.SupportResource.ResourceType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "url": {
                            "type": "string",
                            "id": 2
                          },
                          "phone": {
                            "type": "string",
                            "id": 3
                          }
                        },
                        "nested": {
                          "ResourceType": {
                            "values": {
                              "SR_RT_DO_NOT_USE": 0,
                              "FAQ": 1,
                              "CONTACT_SUPPORT_FORM": 2,
                              "CONTACT_SUPPORT_PHONE": 3
                            }
                          },
                          "resource": {
                            "oneof": ["url", "phone"]
                          }
                        }
                      },
                      "PlanEligibility": {
                        "fields": {
                          "paymentPlanEligibility": {
                            "type": "squareup.capital.servicing.plan.models.PaymentPlanEligibility",
                            "id": 2,
                            "rule": "optional"
                          },
                          "planCancellation": {
                            "type": "squareup.capital.servicing.plan.models.PlanCancellation",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "PaymentPlanEligibility": {
                        "fields": {
                          "eligibleDurations": {
                            "type": "squareup.capital.servicing.plan.models.PaymentPlanDuration",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "bucketDecision": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "PlanCancellation": {
                        "fields": {
                          "cancelable": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "planCancellationBlockers": {
                            "type": "squareup.capital.servicing.plan.models.PlanCancellation.CancellationBlocker",
                            "id": 2,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "CancellationBlocker": {
                            "values": {
                              "S_DO_NOT_USE": 0,
                              "SQUARE_BALANCE_LESS_THAN_PLAN_AMOUNT": 1,
                              "NO_LINKED_BANK_ACCOUNT_FOR_CANCELLATION_DEBIT": 2
                            }
                          }
                        }
                      },
                      "PaymentPlanDuration": {
                        "fields": {
                          "numberExpectedPayments": {
                            "type": "uint32",
                            "id": 2,
                            "rule": "optional"
                          },
                          "cadence": {
                            "type": "squareup.capital.servicing.payment_plan.models.Cadence",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.Plan && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.Plan?.nested?.Status && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.Plan?.nested?.DefaultStatus && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.Plan?.nested?.DefaultStatus?.nested?.Status && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.Plan?.nested?.DefaultStatus?.nested?.Reason && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.Payer && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.Investor && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.Fund && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.Tag && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.Amounts && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.Amounts?.nested?.BaseAmounts && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.Amounts?.nested?.DetailAmounts && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.CovidCadence && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.CovidCadence?.nested?.CovidCadenceType && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.CovidCadence?.nested?.MaturityDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.LoanFixedPaymentsDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.LoanPortionOfSalesDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.McaDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.RisaDetail && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.ScheduledPayment && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.ScheduledPayment?.nested?.Status && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.FinancingTerms?.nested?.Loan && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.FinancingTerms?.nested?.Mca && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.RepaymentTerms?.nested?.PortionOfSales && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.RepaymentTerms?.nested?.FixedPayments && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.RepaymentTerms?.nested?.FixedPayments?.nested?.PaymentFrequency && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.CollectionConfiguration?.nested?.FixedPayments && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.Document && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.Document?.nested?.DocumentType && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.SupportResource && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.SupportResource?.nested?.ResourceType && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.PlanEligibility && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.PaymentPlanEligibility && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.PlanCancellation && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.PlanCancellation?.nested?.CancellationBlocker && !$root.nested?.squareup?.nested?.capital?.nested?.servicing?.nested?.plan?.nested?.models?.nested?.PaymentPlanDuration) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Plan @ squareup/capital/servicing/plan/models.proto at 17:1
 */
export const Plan = $root.lookupType('squareup.capital.servicing.plan.models.Plan');
fixType(Plan, {
  id: {
    required: true
  },
  status: {
    required: true
  }
});
Builder.createAndAttachToType(Plan);
/**
 * SOURCE Status @ squareup/capital/servicing/plan/models.proto at 33:3
 */
Plan.Status = $root.lookupEnum('squareup.capital.servicing.plan.models.Plan.Status').values;
/**
 * SOURCE DefaultStatus @ squareup/capital/servicing/plan/models.proto at 57:3
 */
Plan.DefaultStatus = $root.lookupType('squareup.capital.servicing.plan.models.Plan.DefaultStatus');
fixType(Plan.DefaultStatus);
Builder.createAndAttachToType(Plan.DefaultStatus);
/**
 * SOURCE Status @ squareup/capital/servicing/plan/models.proto at 58:5
 */
Plan.DefaultStatus.Status = $root.lookupEnum('squareup.capital.servicing.plan.models.Plan.DefaultStatus.Status').values;
/**
 * SOURCE Reason @ squareup/capital/servicing/plan/models.proto at 72:5
 */
Plan.DefaultStatus.Reason = $root.lookupEnum('squareup.capital.servicing.plan.models.Plan.DefaultStatus.Reason').values;
/**
 * --
 * @desc Represents a Customer that is responsible for a Plan.
 * If the Payer is marked as primary then all credits / debits are made against this Customer.
 * There can be multiple Payers per Plan but for non-RISA Plans, only one may be the primary.
 * --
 *
 * SOURCE Payer @ squareup/capital/servicing/plan/models.proto at 184:1
 */
export const Payer = $root.lookupType('squareup.capital.servicing.plan.models.Payer');
fixType(Payer, {
  customerId: {
    required: true
  }
});
Builder.createAndAttachToType(Payer);
/**
 * SOURCE Investor @ squareup/capital/servicing/plan/models.proto at 205:1
 */
export const Investor = $root.lookupType('squareup.capital.servicing.plan.models.Investor');
fixType(Investor, {
  id: {
    required: true
  },
  name: {
    required: true
  }
});
Builder.createAndAttachToType(Investor);
/**
 * SOURCE Fund @ squareup/capital/servicing/plan/models.proto at 214:1
 */
export const Fund = $root.lookupType('squareup.capital.servicing.plan.models.Fund');
fixType(Fund, {
  id: {
    required: true
  },
  name: {
    required: true
  }
});
Builder.createAndAttachToType(Fund);
/**
 * SOURCE Tag @ squareup/capital/servicing/plan/models.proto at 223:1
 */
export const Tag = $root.lookupType('squareup.capital.servicing.plan.models.Tag');
fixType(Tag, {
  name: {
    required: true
  }
});
Builder.createAndAttachToType(Tag);
/**
 * Describes mutable dollar amounts pertaining to a plan.
 *
 * SOURCE Amounts @ squareup/capital/servicing/plan/models.proto at 228:1
 */
export const Amounts = $root.lookupType('squareup.capital.servicing.plan.models.Amounts');
fixType(Amounts);
Builder.createAndAttachToType(Amounts);
/**
 * Simplest amounts for the plan. paid + remaining = principle + fee + penalty
 *
 * SOURCE BaseAmounts @ squareup/capital/servicing/plan/models.proto at 230:3
 */
Amounts.BaseAmounts = $root.lookupType('squareup.capital.servicing.plan.models.Amounts.BaseAmounts');
fixType(Amounts.BaseAmounts);
Builder.createAndAttachToType(Amounts.BaseAmounts);
/**
 * Here we subdivide the remaining amount into different types of amounts. Late fees,
 * past due, due, and the remainder remaining amount. All amounts still sum to
 * total owed.
 *
 * SOURCE DetailAmounts @ squareup/capital/servicing/plan/models.proto at 238:3
 */
Amounts.DetailAmounts = $root.lookupType('squareup.capital.servicing.plan.models.Amounts.DetailAmounts');
fixType(Amounts.DetailAmounts);
Builder.createAndAttachToType(Amounts.DetailAmounts);
/**
 * SOURCE CovidCadence @ squareup/capital/servicing/plan/models.proto at 260:1
 */
export const CovidCadence = $root.lookupType('squareup.capital.servicing.plan.models.CovidCadence');
fixType(CovidCadence);
Builder.createAndAttachToType(CovidCadence);
/**
 * SOURCE CovidCadenceType @ squareup/capital/servicing/plan/models.proto at 261:3
 */
CovidCadence.CovidCadenceType = $root.lookupEnum('squareup.capital.servicing.plan.models.CovidCadence.CovidCadenceType').values;
/**
 * SOURCE MaturityDetail @ squareup/capital/servicing/plan/models.proto at 275:3
 */
CovidCadence.MaturityDetail = $root.lookupType('squareup.capital.servicing.plan.models.CovidCadence.MaturityDetail');
fixType(CovidCadence.MaturityDetail);
Builder.createAndAttachToType(CovidCadence.MaturityDetail);
/**
 * SOURCE LoanFixedPaymentsDetail @ squareup/capital/servicing/plan/models.proto at 281:1
 */
export const LoanFixedPaymentsDetail = $root.lookupType('squareup.capital.servicing.plan.models.LoanFixedPaymentsDetail');
fixType(LoanFixedPaymentsDetail);
Builder.createAndAttachToType(LoanFixedPaymentsDetail);
/**
 * SOURCE LoanPortionOfSalesDetail @ squareup/capital/servicing/plan/models.proto at 392:1
 */
export const LoanPortionOfSalesDetail = $root.lookupType('squareup.capital.servicing.plan.models.LoanPortionOfSalesDetail');
fixType(LoanPortionOfSalesDetail, {
  financingTerms: {
    required: true
  },
  repaymentTerms: {
    required: true
  }
});
Builder.createAndAttachToType(LoanPortionOfSalesDetail);
/**
 * SOURCE McaDetail @ squareup/capital/servicing/plan/models.proto at 457:1
 */
export const McaDetail = $root.lookupType('squareup.capital.servicing.plan.models.McaDetail');
fixType(McaDetail, {
  financingTerms: {
    required: true
  },
  repaymentTerms: {
    required: true
  }
});
Builder.createAndAttachToType(McaDetail);
/**
 * TODO: build out support
 *
 * SOURCE RisaDetail @ squareup/capital/servicing/plan/models.proto at 475:1
 */
export const RisaDetail = $root.lookupType('squareup.capital.servicing.plan.models.RisaDetail');
fixType(RisaDetail);
Builder.createAndAttachToType(RisaDetail);
/**
 * Phase 2
 *
 * SOURCE ScheduledPayment @ squareup/capital/servicing/plan/models.proto at 481:1
 */
export const ScheduledPayment = $root.lookupType('squareup.capital.servicing.plan.models.ScheduledPayment');
fixType(ScheduledPayment, {
  status: {
    required: true
  },
  debitedAt: {
    required: true
  },
  debitMoney: {
    required: true
  },
  lateFeeAppliedAt: {
    required: true
  },
  lateFeeMoney: {
    required: true
  },
  remainingNonDueMoney: {
    required: true
  },
  remainingDueMoney: {
    required: true
  },
  remainingPastDueMoney: {
    required: true
  },
  remainingLateFeeMoney: {
    required: true
  }
});
Builder.createAndAttachToType(ScheduledPayment);
/**
 * SOURCE Status @ squareup/capital/servicing/plan/models.proto at 482:3
 */
ScheduledPayment.Status = $root.lookupEnum('squareup.capital.servicing.plan.models.ScheduledPayment.Status').values;
/**
 * Lifted from protos/squareup/capital/external/business/models/offers.proto.
 * The original is not compliant with the style guide, and we want to use compliant API's.
 *
 * SOURCE FinancingTerms @ squareup/capital/servicing/plan/models.proto at 524:1
 */
export const FinancingTerms = {};
/**
 * SOURCE Loan @ squareup/capital/servicing/plan/models.proto at 525:3
 */
FinancingTerms.Loan = $root.lookupType('squareup.capital.servicing.plan.models.FinancingTerms.Loan');
fixType(FinancingTerms.Loan, {
  financedMoney: {
    required: true
  },
  feeMoney: {
    required: true
  },
  depositMoney: {
    required: true
  },
  outstandingBalanceMoney: {
    required: true
  },
  totalOwedMoney: {
    required: true
  },
  aprBps: {
    required: true
  },
  lateFeeBps: {
    required: true
  },
  postMaturitySweeperBps: {
    required: true
  },
  feeAmountBps: {
    required: true
  }
});
Builder.createAndAttachToType(FinancingTerms.Loan);
/**
 * SOURCE Mca @ squareup/capital/servicing/plan/models.proto at 556:3
 */
FinancingTerms.Mca = $root.lookupType('squareup.capital.servicing.plan.models.FinancingTerms.Mca');
fixType(FinancingTerms.Mca, {
  financedMoney: {
    required: true
  },
  feeMoney: {
    required: true
  },
  depositMoney: {
    required: true
  },
  outstandingBalanceMoney: {
    required: true
  },
  totalOwedMoney: {
    required: true
  },
  feeAmountBps: {
    required: true
  }
});
Builder.createAndAttachToType(FinancingTerms.Mca);
/**
 * Also lifted from protos/squareup/capital/external/business/models/offers.proto.
 *
 * SOURCE RepaymentTerms @ squareup/capital/servicing/plan/models.proto at 580:1
 */
export const RepaymentTerms = {};
/**
 * SOURCE PortionOfSales @ squareup/capital/servicing/plan/models.proto at 581:3
 */
RepaymentTerms.PortionOfSales = $root.lookupType('squareup.capital.servicing.plan.models.RepaymentTerms.PortionOfSales');
fixType(RepaymentTerms.PortionOfSales, {
  holdRateBps: {
    required: true
  },
  minimumPaymentMoney: {
    required: true
  }
});
Builder.createAndAttachToType(RepaymentTerms.PortionOfSales);
/**
 * SOURCE FixedPayments @ squareup/capital/servicing/plan/models.proto at 598:3
 */
RepaymentTerms.FixedPayments = $root.lookupType('squareup.capital.servicing.plan.models.RepaymentTerms.FixedPayments');
fixType(RepaymentTerms.FixedPayments, {
  paymentMoney: {
    required: true
  },
  finalPaymentMoney: {
    required: true
  },
  paymentCount: {
    required: true
  },
  paymentFrequency: {
    required: true
  }
});
Builder.createAndAttachToType(RepaymentTerms.FixedPayments);
/**
 * Intentionally not setting up an iCalendar recurrence rule definition
 * here. This is much simpler than that RFC and this cannot have a start
 * date until the application is approved.
 *
 * SOURCE PaymentFrequency @ squareup/capital/servicing/plan/models.proto at 602:5
 */
RepaymentTerms.FixedPayments.PaymentFrequency = $root.lookupEnum('squareup.capital.servicing.plan.models.RepaymentTerms.FixedPayments.PaymentFrequency').values;
/**
 * SOURCE CollectionConfiguration @ squareup/capital/servicing/plan/models.proto at 618:1
 */
export const CollectionConfiguration = {};
/**
 * SOURCE FixedPayments @ squareup/capital/servicing/plan/models.proto at 619:3
 */
CollectionConfiguration.FixedPayments = $root.lookupType('squareup.capital.servicing.plan.models.CollectionConfiguration.FixedPayments');
fixType(CollectionConfiguration.FixedPayments);
Builder.createAndAttachToType(CollectionConfiguration.FixedPayments);
/**
 * SOURCE Document @ squareup/capital/servicing/plan/models.proto at 628:1
 */
export const Document = $root.lookupType('squareup.capital.servicing.plan.models.Document');
fixType(Document, {
  createdAt: {
    required: true
  },
  type: {
    required: true
  },
  url: {
    required: true
  }
});
Builder.createAndAttachToType(Document);
/**
 * SOURCE DocumentType @ squareup/capital/servicing/plan/models.proto at 629:3
 */
Document.DocumentType = $root.lookupEnum('squareup.capital.servicing.plan.models.Document.DocumentType').values;
/**
 * Provides arbitrary support resources. Has a type enum so that the frontend
 * can implement specialized handling for any known resource. Initially this
 * only provides URLs but it can be expanded for email, twitter, etc.
 *
 * SOURCE SupportResource @ squareup/capital/servicing/plan/models.proto at 652:1
 */
export const SupportResource = $root.lookupType('squareup.capital.servicing.plan.models.SupportResource');
fixType(SupportResource);
Builder.createAndAttachToType(SupportResource);
/**
 * SOURCE ResourceType @ squareup/capital/servicing/plan/models.proto at 653:3
 */
SupportResource.ResourceType = $root.lookupEnum('squareup.capital.servicing.plan.models.SupportResource.ResourceType').values;
/**
 * All eligibility for a Plan.
 *
 * SOURCE PlanEligibility @ squareup/capital/servicing/plan/models.proto at 673:1
 */
export const PlanEligibility = $root.lookupType('squareup.capital.servicing.plan.models.PlanEligibility');
fixType(PlanEligibility, {
  paymentPlanEligibility: {
    required: true
  },
  planCancellation: {
    required: true
  }
});
Builder.createAndAttachToType(PlanEligibility);
/**
 * All elgibility in regards to Payment Plans.
 *
 * SOURCE PaymentPlanEligibility @ squareup/capital/servicing/plan/models.proto at 685:1
 */
export const PaymentPlanEligibility = $root.lookupType('squareup.capital.servicing.plan.models.PaymentPlanEligibility');
fixType(PaymentPlanEligibility);
Builder.createAndAttachToType(PaymentPlanEligibility);
/**
 * Contains data related to plan cancellation.
 *
 * SOURCE PlanCancellation @ squareup/capital/servicing/plan/models.proto at 703:1
 */
export const PlanCancellation = $root.lookupType('squareup.capital.servicing.plan.models.PlanCancellation');
fixType(PlanCancellation);
Builder.createAndAttachToType(PlanCancellation);
/**
 * SOURCE CancellationBlocker @ squareup/capital/servicing/plan/models.proto at 704:3
 */
PlanCancellation.CancellationBlocker = $root.lookupEnum('squareup.capital.servicing.plan.models.PlanCancellation.CancellationBlocker').values;
/**
 * A duration of a Payment Plan.
 *
 * SOURCE PaymentPlanDuration @ squareup/capital/servicing/plan/models.proto at 718:1
 */
export const PaymentPlanDuration = $root.lookupType('squareup.capital.servicing.plan.models.PaymentPlanDuration');
fixType(PaymentPlanDuration, {
  numberExpectedPayments: {
    required: true
  },
  cadence: {
    required: true
  }
});
Builder.createAndAttachToType(PaymentPlanDuration);